import React from 'react';
import { useAuthContext } from '../../contexts/AuthContext';

const NoOrganizationAccess = () => {
  const { user, logout } = useAuthContext();

  const handleSignOut = async () => {
    try {
      await logout();
    } catch {
      /* ignore */
    }
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-lg w-full bg-white rounded-lg shadow-md p-8 text-center">
        <h1 className="text-2xl font-semibold text-gray-900 mb-3">No organization access</h1>
        <p className="text-gray-600 mb-4">
          {user?.email ? (
            <>
              <span className="font-medium text-gray-800">{user.email}</span> is signed in, but this
              account is not linked to any practice organization yet.
            </>
          ) : (
            'Your account is not linked to any practice organization yet.'
          )}
        </p>
        <ul className="text-left text-sm text-gray-600 space-y-2 mb-6">
          <li>Sign in with the email that received the team invitation.</li>
          <li>If you created the practice under a different email, use that address instead.</li>
          <li>Ask your practice administrator to send a new invitation to this email.</li>
        </ul>
        <button
          type="button"
          onClick={handleSignOut}
          className="inline-flex justify-center px-4 py-2 rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Sign out and try another account
        </button>
      </div>
    </div>
  );
};

export default NoOrganizationAccess;
